import DataUsageIcon from "@mui/icons-material/DataUsage";
import { Button, CircularProgress, Stack, Tooltip, Typography } from "@mui/material";
import { useAPIKeyContext } from "../../contexts/api-key-context";
import { useApiQuery } from "../../hooks";

interface SimpleUsage {
  period_usage: number;
  period_limit: number;
  period: string;
}

const APP_URL = import.meta.env.VITE_APP_URL || "https://app.desplega.ai";

export function DemoCreditsDisplay() {
  const { apiKey } = useAPIKeyContext();

  const { data, isLoading } = useApiQuery<SimpleUsage>(
    "/vibe-qa/usage",
    {
      enabled: !!apiKey,
      refetchInterval: 10000,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      staleTime: 5000,
    },
    apiKey,
  );

  const handleUpgradeClick = () => {
    window.open(APP_URL, "_blank");
  };

  if (isLoading) {
    return <CircularProgress size={16} />;
  }

  if (!data) {
    return null;
  }

  const usagePercent =
    data.period_limit > 0 ? Math.round((data.period_usage / data.period_limit) * 100) : 0;

  const isLow = usagePercent > 80;

  return (
    <Tooltip title="Click to login and upgrade your plan">
      <Button
        size="small"
        variant="outlined"
        color={isLow ? "warning" : "inherit"}
        onClick={handleUpgradeClick}
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "4px 8px",
          fontSize: "12px",
          fontWeight: 500,
          borderRadius: "6px",
          cursor: "pointer",
          minWidth: "auto",
        }}
      >
        <Stack direction="row" spacing={0.5} alignItems="center">
          <DataUsageIcon sx={{ width: "14px", height: "14px" }} />
          <Typography variant="caption" sx={{ fontWeight: 500 }}>
            {data.period_usage} / {data.period_limit}
          </Typography>
        </Stack>
      </Button>
    </Tooltip>
  );
}
